(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_aromatale-pulse-badge"] && !Shopify.designMode) return;
  try {
    (() => {
    const blocks = document.querySelectorAll('[data-aromatale-pulse-badge]');
    if (!blocks.length) return;

    const translations = {
      lt: {
        green: 'Yra sandėlyje: __QUANTITY__ vnt.',
        orange: 'Greitai baigsis: liko __QUANTITY__',
        red: 'Likučio neturime'
      },
      lv: {
        green: 'Ir noliktavā: __QUANTITY__ gab.',
        orange: 'Drīz beigsies: atlikuši __QUANTITY__',
        red: 'Nav noliktavā'
      },
      et: {
        green: 'Laos: __QUANTITY__ tk',
        orange: 'Peagi otsas: jäänud __QUANTITY__',
        red: 'Laos puudub'
      },
      fi: {
        green: 'Varastossa: __QUANTITY__ kpl',
        orange: 'Loppumassa: jäljellä __QUANTITY__',
        red: 'Ei varastossa'
      },
      en: {
        green: 'In stock: __QUANTITY__ pcs',
        orange: 'Low stock: only __QUANTITY__ left',
        red: 'Out of stock'
      }
    };

    const numberFrom = (value, fallback = 0) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    const parseVariants = (block) => {
      try {
        return JSON.parse(block.querySelector('[data-aromatale-pulse-badge-variants]')?.textContent || '[]');
      } catch (error) {
        return [];
      }
    };

    const getProductScope = (block) => block.closest('.hdt-group-product-block') || block.closest('[id^="shopify-section-"]') || document;

    const getVariantIdFromUrl = () => {
      try {
        return Number(new URL(window.location.href).searchParams.get('variant'));
      } catch (error) {
        return NaN;
      }
    };

    const getVariantFromEvent = (event) => {
      const detail = event?.detail || {};
      const candidates = [
        detail.variant,
        detail.currentVariant,
        detail.selectedVariant,
        detail.resource,
        detail
      ];

      return candidates.find((candidate) => candidate && typeof candidate === 'object' && candidate.id);
    };

    const getVariantFromSelectedScript = (scope) => {
      const script = scope.querySelector('script[id^="selected-variant-"]');
      if (!script) return null;

      try {
        const parsed = JSON.parse(script.textContent || '{}');
        if (parsed && typeof parsed === 'object' && parsed.id) {
          return {
            id: Number(parsed.id),
            inventory_quantity: numberFrom(parsed.inventory_quantity ?? script.dataset.inventoryquantity, 0),
            inventory_management: parsed.inventory_management,
            inventory_policy: parsed.inventory_policy,
            available: parsed.available
          };
        }
      } catch (error) {
        return null;
      }

      return null;
    };

    const getSelectedVariantId = (block) => {
      const scope = getProductScope(block);
      const picker = scope.querySelector('hdt-variant-picker[selected-variant]');
      const formId = picker?.getAttribute('form');
      const form = formId ? document.getElementById(formId) : scope.querySelector('form[action*="/cart/add"]');
      const input = form?.querySelector('[name="id"]') || scope.querySelector('[name="id"]');
      const selectedScriptVariant = getVariantFromSelectedScript(scope);
      const candidates = [
        input?.value,
        picker?.getAttribute('selected-variant'),
        selectedScriptVariant?.id,
        getVariantIdFromUrl(),
        block._aromatalePulseLastVariant?.id
      ];

      return Number(candidates.find((candidate) => Number.isFinite(Number(candidate)) && Number(candidate) > 0));
    };

    const mergeVariantData = (variant, eventVariant) => {
      if (!eventVariant) return variant;

      return {
        ...variant,
        id: Number(eventVariant.id || variant?.id),
        inventory_quantity: numberFrom(eventVariant.inventory_quantity ?? eventVariant.inventoryQuantity ?? eventVariant.quantity, variant?.inventory_quantity),
        inventory_management: eventVariant.inventory_management ?? eventVariant.inventoryManagement ?? variant?.inventory_management,
        inventory_policy: eventVariant.inventory_policy ?? eventVariant.inventoryPolicy ?? variant?.inventory_policy,
        available: eventVariant.available ?? variant?.available
      };
    };

    const hasInventoryData = (variant) => variant && variant.inventory_quantity !== undefined && variant.inventory_quantity !== null;

    const isTracked = (variant) => variant && variant.inventory_management !== null && variant.inventory_management !== undefined && variant.inventory_management !== '';

    const getStatus = (block, quantity, variant) => {
      const greenThreshold = numberFrom(block.dataset.greenThreshold, 10);
      const orangeMin = numberFrom(block.dataset.orangeMin, 1);
      const orangeMax = numberFrom(block.dataset.orangeMax, 9);
      const showOutOfStock = block.dataset.showOutOfStock === 'true';
      const hideWhenZero = block.dataset.hideWhenZero === 'true';
      const hideUntracked = block.dataset.hideUntracked === 'true';

      if (hideUntracked && variant && !isTracked(variant)) return 'hidden';

      if (quantity >= greenThreshold) return 'green';
      if (quantity >= orangeMin && quantity <= orangeMax) return 'orange';
      if (quantity > 0) return 'orange';
      if (quantity === 0) {
        if (hideWhenZero || !showOutOfStock) return 'hidden';
        return 'red';
      }

      return 'hidden';
    };

    const render = (block, eventVariant = null) => {
      const variants = block._aromatalePulseVariants || (block._aromatalePulseVariants = parseVariants(block));
      const inner = block.querySelector('[data-aromatale-pulse-badge-inner]');
      const text = block.querySelector('[data-aromatale-pulse-badge-text]');
      if (!inner || !text) return;

      const manualText = block.dataset.manualText || '';
      const source = block.dataset.inventorySource;
      const selectedVariantId = getSelectedVariantId(block);
      const scope = getProductScope(block);
      const scriptVariant = getVariantFromSelectedScript(scope);
      const selectedVariant = mergeVariantData(
        variants.find((variant) => Number(variant.id) === selectedVariantId) || scriptVariant || block._aromatalePulseLastVariant || variants[0],
        eventVariant || scriptVariant
      );

      if (selectedVariant && selectedVariant.id) {
        block._aromatalePulseLastVariant = selectedVariant;
      }

      if (source !== 'manual' && !hasInventoryData(selectedVariant)) {
        if (block._aromatalePulseLastState) {
          inner.dataset.status = block._aromatalePulseLastState.status;
          text.textContent = block._aromatalePulseLastState.text;
          block.hidden = false;
        } else {
          block.hidden = true;
        }
        return;
      }

      const quantity = source === 'manual'
        ? numberFrom(block.dataset.manualQuantity, 0)
        : numberFrom(selectedVariant?.inventory_quantity, 0);
      let status = getStatus(block, quantity, selectedVariant);

      if (manualText) {
        text.textContent = manualText;
        if (status === 'hidden') status = 'green';
      } else {
        const requestedLocale = (block.dataset.locale || 'en').slice(0, 2).toLowerCase();
        const locale = translations[requestedLocale] ? requestedLocale : 'en';
        const copy = translations[locale][status];

        if (!copy) {
          block.hidden = true;
          return;
        }

        text.textContent = copy.replace('__QUANTITY__', String(quantity));
      }

      inner.dataset.status = status;
      block.hidden = status === 'hidden';
      block.classList.toggle('aromatale-pulse-badge--is-green', status === 'green');
      block.classList.toggle('aromatale-pulse-badge--is-orange', status === 'orange');
      block.classList.toggle('aromatale-pulse-badge--is-red', status === 'red');

      if (status !== 'hidden' && text.textContent.trim()) {
        block._aromatalePulseLastState = {
          status,
          text: text.textContent
        };
      } else if (!text.textContent.trim()) {
        block.hidden = true;
      }
    };

    const scheduleRender = (block, eventVariant = null) => {
      window.requestAnimationFrame(() => render(block, eventVariant));
      window.setTimeout(() => render(block, eventVariant), 80);
      window.setTimeout(() => render(block, eventVariant), 220);
    };

    blocks.forEach((block) => {
      if (block.dataset.aromatalePulseBadgeInitialized === 'true') return;
      block.dataset.aromatalePulseBadgeInitialized = 'true';

      const scope = getProductScope(block);
      const picker = scope.querySelector('hdt-variant-picker');
      const formId = picker?.getAttribute('form');
      const form = formId ? document.getElementById(formId) : null;
      const variantInput = form?.querySelector('[name="id"]') || scope.querySelector('[name="id"]');

      render(block);
      ['change', 'input', 'click', 'variant:selected', 'variant:update', 'variant:updated', 'variant:change', 'product:variant-change'].forEach((eventName) => {
        scope.addEventListener(eventName, (event) => scheduleRender(block, getVariantFromEvent(event)), true);
        document.addEventListener(eventName, (event) => {
          if (scope.contains(event.target) || event.target === scope || getVariantFromEvent(event)) {
            scheduleRender(block, getVariantFromEvent(event));
          }
        }, true);
      });

      if (form) {
        form.addEventListener('change', () => scheduleRender(block), true);
      }

      if (picker && window.MutationObserver) {
        new MutationObserver(() => scheduleRender(block)).observe(picker, {
          attributes: true,
          attributeFilter: ['selected-variant']
        });
      }

      if (variantInput && window.MutationObserver) {
        let lastValue = variantInput.value;
        new MutationObserver(() => {
          if (variantInput.value !== lastValue) {
            lastValue = variantInput.value;
            scheduleRender(block);
          }
        }).observe(variantInput, {
          attributes: true,
          attributeFilter: ['value']
        });

        variantInput.addEventListener('change', () => scheduleRender(block), true);
        variantInput.addEventListener('input', () => scheduleRender(block), true);
      }

      window.addEventListener('popstate', () => scheduleRender(block));
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_aromatale-shipping-info"] && !Shopify.designMode) return;
  try {
    (() => {
    const messages = {
      lt: {
        before: 'Išsiųsime šiandien',
        after: 'Išsiųsime nuo <strong>__DATE__</strong>',
        right: 'Greitas pristatymas',
        days: { 1: 'pr', 2: 'an', 3: 'tr', 4: 'kt', 5: 'pn' }
      },
      lv: {
        before: 'Nosūtīsim šodien',
        after: 'Nosūtīsim no <strong>__DATE__</strong>',
        right: 'Ātra piegāde',
        days: { 1: 'pr', 2: 'ot', 3: 'tr', 4: 'ce', 5: 'pk' }
      },
      et: {
        before: 'Saadame täna',
        after: 'Saadame alates <strong>__DATE__</strong>',
        right: 'Kiire tarne',
        days: { 1: 'E', 2: 'T', 3: 'K', 4: 'N', 5: 'R' }
      },
      fi: {
        before: 'Lähetämme tänään',
        after: 'Lähetämme alkaen <strong>__DATE__</strong>',
        right: 'Nopea toimitus',
        days: { 1: 'ma', 2: 'ti', 3: 'ke', 4: 'to', 5: 'pe' }
      }
    };

    const cutoffMinutes = 14 * 60;
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Vilnius',
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });

    const getVilniusParts = (date) => {
      const parts = formatter.formatToParts(date).reduce((result, part) => {
        result[part.type] = part.value;
        return result;
      }, {});

      return {
        year: Number(parts.year),
        month: Number(parts.month),
        day: Number(parts.day),
        hour: Number(parts.hour),
        minute: Number(parts.minute)
      };
    };

    const isBusinessDay = (day) => day >= 1 && day <= 5;

    const getShippingDate = (now = new Date()) => {
      const vilnius = getVilniusParts(now);
      let candidate = new Date(Date.UTC(vilnius.year, vilnius.month - 1, vilnius.day));
      const weekday = candidate.getUTCDay();
      const minutes = vilnius.hour * 60 + vilnius.minute;
      const shipsToday = isBusinessDay(weekday) && minutes < cutoffMinutes;

      if (shipsToday) {
        return { shipsToday, date: candidate };
      }

      do {
        candidate.setUTCDate(candidate.getUTCDate() + 1);
      } while (!isBusinessDay(candidate.getUTCDay()));

      return { shipsToday, date: candidate };
    };

    const formatShippingDate = (date, language) => {
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      const weekday = messages[language].days[date.getUTCDay()];
      return `${month}-${day}, ${weekday}`;
    };

    const render = (block) => {
      const requestedLanguage = (block.dataset.locale || '').slice(0, 2).toLowerCase();
      const language = messages[requestedLanguage] ? requestedLanguage : 'lt';
      const copy = messages[language];
      const shipping = getShippingDate();
      const message = block.querySelector('[data-aromatale-shipping-message]');
      const label = block.querySelector('[data-aromatale-shipping-label]');

      if (!message || !label) return;

      message.innerHTML = shipping.shipsToday
        ? copy.before
        : copy.after.replace('__DATE__', formatShippingDate(shipping.date, language));
      label.textContent = copy.right;
    };

    document.querySelectorAll('[data-aromatale-shipping-info]').forEach(render);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_aromatale-social-proof"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROTATION_INTERVAL = 2800;
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const initAromataleSocialProof = (root = document) => {
      root.querySelectorAll('[data-aromatale-social-proof-avatars][data-rotate="true"]:not([data-rotator-ready])').forEach((avatarGroup) => {
        const avatars = Array.from(avatarGroup.querySelectorAll('.aromatale-social-proof__avatar'));

        if (avatars.length <= 3) return;

        avatarGroup.dataset.rotatorReady = 'true';

        let offset = 0;
        let interval = null;
        let isVisible = true;

        const render = () => {
          avatars.forEach((avatar, index) => {
            const rawSlot = index - offset;
            const slot = ((rawSlot % avatars.length) + avatars.length) % avatars.length;

            if (slot < 3) {
              avatar.classList.add('is-active');
              avatar.style.setProperty('--aromatale-social-proof-avatar-slot', slot);
              avatar.style.setProperty('--aromatale-social-proof-avatar-z', 3 - slot);
            } else {
              avatar.classList.remove('is-active');
            }
          });
        };

        const rotate = () => {
          offset = (offset + 1) % avatars.length;
          render();
        };

        const stop = () => {
          if (!interval) return;
          window.clearInterval(interval);
          interval = null;
        };

        const start = () => {
          if (interval || reducedMotionQuery.matches || !isVisible) return;
          interval = window.setInterval(() => {
            if (!document.body.contains(avatarGroup)) {
              stop();
              return;
            }

            rotate();
          }, ROTATION_INTERVAL);
        };

        render();

        if (!reducedMotionQuery.matches) {
          if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries) => {
              isVisible = entries.some((entry) => entry.isIntersecting);

              if (isVisible) {
                start();
              } else {
                stop();
              }
            }, { threshold: 0.05 });

            observer.observe(avatarGroup);
          } else {
            start();
          }
        }

        const handleMotionChange = () => {
          if (reducedMotionQuery.matches) {
            stop();
            offset = 0;
            render();
          } else {
            start();
          }
        };

        if (typeof reducedMotionQuery.addEventListener === 'function') {
          reducedMotionQuery.addEventListener('change', handleMotionChange);
        } else if (typeof reducedMotionQuery.addListener === 'function') {
          reducedMotionQuery.addListener(handleMotionChange);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAromataleSocialProof());
    } else {
      initAromataleSocialProof();
    }

    document.addEventListener('shopify:section:load', (event) => initAromataleSocialProof(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
